import axios from 'axios';

window.TABS = window.TABS || {};

window.TABS.optima = {
    step: null,
    userType: 'student',
    exists: false,
    runDSF: true,
    freeInterpreterSlots: 0,
    freeSlots: 0,
    userId: null,
    hash: '',
    mobile: '',
    pw: '',
    fnr: '',
    addStudentIds: [],
    withInterpreter: [],
    courseId: null,
    classId: null,
    teacherId: null,
    productId: null,
    productType: null,
    start: null,
    end: null,
    transactionRef: null,
    statusAttempts: 0,
    statusMaxAttempts: 100,
    secondsBetweenEachCheck: 3,
    reservationTimeout: null,
    modalCloseHandler: null,
    shippingAddress: {},
    deliveryOption: null,
    resourceClassIds: {},
    isDeliverable: false,
    hasResourcePool: false,
    postingForm: false,
    productTerms: [],
    netsCallbackRegistered: false,
    comment: '',

    init: function () {
        if (document.querySelectorAll('[data-booking-step=booking-type-select]').length) {
            TABS.optima.resetUser();
            TABS.optima.checkInterpreterCount();
            return;
        }
        TABS.optima.initStudent();
        // TABS.booking.showStep('deliveryOptions')
        // TABS.booking.showStep('optimaRegister')
        // TABS.booking.showStep('confirmMobile')
        // TABS.booking.showStep('optimaPayment')
        // TABS.booking.showStep('addStudent')
        // TABS.booking.showStep('addStudentOrPay')
        TABS.optima.checkInterpreterCount();

        TABS.optima.iframeSwishCheck();
    },

    goBack: function () {
        document.querySelectorAll('[data-booking-step=' + TABS.optima.step + '] input:not([type=hidden]):not([type=checkbox])').forEach(input => {
            input.value = '';
            input.removeAttribute('readonly');
        });
        switch (TABS.optima.step) {
            case 'confirmMobile':
            case 'login':
                if (TABS.optima.userType === 'contact') {
                    return TABS.optima.initContact();
                }
                return TABS.optima.initStudent();
            case 'addStudent':
                TABS.optima.fnr = '';
                document.querySelector('.register-details').classList.add('hide');
                return TABS.booking.showStep('addStudentOrPay');
        }
    },

    checkInterpreterCount: function () {
        const elements = document.querySelectorAll('.with-interpreter-check');
        if (TABS.optima.freeInterpreterSlots > TABS.optima.withInterpreter.length) {
            elements.forEach(el => el.classList.remove('d-none', 'hidden'));
        } else {
            elements.forEach(el => el.classList.add('d-none', 'hidden'));
        }
    },

    initStudent: function () {
        TABS.optima.resetUser();
        TABS.optima.userType = 'student';
        TABS.optima.step = 'initStudent';
        TABS.booking.showStep(TABS.optima.step);
    },
    initContact: function () {
        TABS.optima.resetUser();
        TABS.optima.userType = 'contact';
        TABS.optima.step = 'initContact';
        TABS.booking.showStep(TABS.optima.step);
    },

    resetUser: function () {
        TABS.optima.step = 'init';
        TABS.optima.userType = 'student';
        TABS.optima.exists = false;
        TABS.optima.runDSF = true;
        TABS.optima.userId = null;
        TABS.optima.hash = '';
        TABS.optima.mobile = '';
        TABS.optima.fnr = '';
        TABS.optima.pw = '';
        TABS.optima.transactionRef = null;
        TABS.optima.swishQr = '';
        TABS.optima.addStudentIds = [];
        TABS.optima.withInterpreter = [];
        TABS.optima.shippingAddress = {};
        TABS.optima.productTerms = [];
    },

    lookup: function (e) {
        e.preventDefault();
        if (!TABS.booking.shouldSubmit(e, TABS.optima.step)) {
            return;
        }
        const $form = document.querySelector('[data-booking-step=' + TABS.optima.step + ']');
        TABS.booking.request('check_mobile', $form, TABS.optima.lookupSuccessCallback);
    },
    // Lookup success response callback
    lookupSuccessCallback: function (res, form) {
        form.querySelector('.btn-primary').removeAttribute('disabled');
        form.querySelector('.btn-primary').textContent = TABS.$t('Fortsett');
        const mobileVal = form.querySelector('input[name=mobile]').value;
        document.querySelectorAll('input[name=mobile]:not(.no-copy)').forEach(el => el.value = mobileVal);
        if (res.error) {
            return TABS.booking.showError(res.error);
        }

        if (res.isMobile && TABS.api.inIframe() && !TABS.api.loadedOutsideIframe) {
            const triggerSwishButton = document.getElementById('trigger-swish-button');
            if (triggerSwishButton) {
                triggerSwishButton.remove();
            }
        }

        TABS.optima.exists = res.exists;

        if (res.exists) {
            TABS.optima.step = 'login';
            TABS.booking.showStep(TABS.optima.step);
            TABS.booking.showSuccess(res.message);
            return;
        }
        TABS.optima.step = 'confirmMobile';
        TABS.booking.showStep(TABS.optima.step);
        TABS.booking.showSuccess(res.message);
    },

    dsfCheck: function (e) {
        const fnr = e.target.value;

        if (fnr === TABS.optima.fnr) {
            // Already ran this request
            return;
        }
        TABS.optima.fnr = fnr;

        if (!TABS.optima.runDSF && TABS.optima.step === 'optimaRegister') {
            // DSF disabled, don't do anything
            return;
        }

        const $form = document.querySelector('[data-booking-step=' + TABS.optima.step + ']');
        if (!TABS.L10n.nationalNumber.parse(e.target.value).isValidNationalNumber()) {
            return TABS.optima.resetRegisterForm();
        }

        TABS.booking.setFeedback('');
        TABS.validation.clearValidationErrors($form);
        TABS.booking.setLoading(true);
        TABS.booking.request('optima-dsf', $form, function (res, form) {
            TABS.booking.setLoading(false);

            form.querySelectorAll('.btn-primary').forEach(el => {
                el.removeAttribute('disabled');
                el.textContent = el.dataset.originalText;
            });
            if (res.success) {
                if (TABS.optima.step === 'addStudent' && res.data.user_id) {
                    form.querySelector('input[name=user_id]').value = res.data.user_id;
                    if (res.data.mobile) {
                        form.querySelector('input[name=mobile]').value = res.data.mobile;
                        form.querySelector('input[name=mobile]').setAttribute('readonly', 'readonly');
                    }
                    if (res.data.email) {
                        form.querySelector('input[name=email]').value = res.data.email;
                        form.querySelector('input[name=email]').setAttribute('readonly', 'readonly');
                    }
                }
                if (res.data.first_name) {
                    form.querySelector('input[name=first_name]').value = res.data.first_name;
                    form.querySelector('input[name=first_name]').setAttribute('readonly', 'readonly');
                }
                if (res.data.last_name) {
                    form.querySelector('input[name=last_name]').value = res.data.last_name;
                    form.querySelector('input[name=last_name]').setAttribute('readonly', 'readonly');
                }
                if (res.data.address) {
                    form.querySelector('input[name=address]').value = res.data.address;
                    form.querySelector('input[name=address]').setAttribute('readonly', 'readonly');
                }
                if (res.data.postal_code) {
                    form.querySelector('input[name=postal_code]').value = res.data.postal_code;
                    form.querySelector('input[name=postal_code]').setAttribute('readonly', 'readonly');
                }
                if (res.data.city) {
                    form.querySelector('input[name=city]').value = res.data.city;
                    form.querySelector('input[name=city]').setAttribute('readonly', 'readonly');
                }
                TABS.optima.runDSF = true;
                document.querySelectorAll('[data-booking-step=' + TABS.optima.step + '] input[name=use-fnr]').forEach(el => el.value = 1);
                document.querySelectorAll('.register-details').forEach(el => el.classList.remove('hide'));
            } else {
                TABS.booking.showError(res.message);
            }
        });
    },

    confirmMobile: function (e) {
        e.preventDefault();
        TABS.booking.request('optima-ottp', document.querySelector('[data-booking-step=' + TABS.optima.step + ']'), function (res, form) {
            form.querySelector('.btn-primary').removeAttribute('disabled');
            form.querySelector('.btn-primary').textContent = TABS.$t('Logg inn');
            if (!res.success) {
                return TABS.booking.showError(res.message);
            }

            TABS.optima.userId = res.user_id;
            TABS.optima.hash = res.hash;
            // Should also store mobile here

            if (res.user_id) {
                return TABS.booking.showStep('optimaPayment');
            }
            TABS.booking.showStep('optimaRegister');
        });
    },

    toggleManualRegistration: function (e) {
        e.preventDefault();
        const button = e.target;
        const currText = button.textContent;
        const toggleText = button.dataset.toggleText;
        button.textContent = toggleText;
        button.dataset.toggleText = currText;

        TABS.optima.runDSF = !TABS.optima.runDSF;
        document.querySelector('[data-booking-step=' + TABS.optima.step + '] input[name=use-fnr]').value = TABS.optima.runDSF ? 1 : 0;
        if (TABS.optima.runDSF) {
            document.querySelector('.register-details').classList.add('hide');
        } else {
            document.querySelector('.register-details').classList.remove('hide');
            document.querySelectorAll('.register-details input[readonly]').forEach(input => {
                input.removeAttribute('readonly');
                input.value = '';
            });
        }

    },

    login: function (e) {
        e.preventDefault();
        const $form = document.querySelector('[data-booking-step=' + TABS.optima.step + ']');
        const loginButton = $form.querySelector('.btn-primary');
        const loginButtonText = loginButton.textContent;
        if (!TABS.booking.shouldSubmit(e, 'login')) {
            return;
        }

        TABS.booking.request('optima-login', $form, function (res, form) {
            form.querySelector('.btn-primary').removeAttribute('disabled');
            form.querySelector('.btn-primary').textContent = loginButtonText;
            if (res.success) {
                if ($form.querySelector('textarea[name=comment]')) {
                    TABS.optima.comment = $form.querySelector('textarea[name=comment]').value;
                }
                TABS.optima.userId = res.user_id;
                if (res.with_interpreter) {
                    TABS.optima.withInterpreter.push(res.user_id);
                    TABS.optima.checkInterpreterCount();
                }
                if (res.product_terms) {
                    TABS.optima.productTerms = res.product_terms;
                }

                TABS.optima.pw = form.querySelector('input[name=password]').value;
                if (res.has_package) {
                    return TABS.booking.showStep('packageBooking');
                }

                if (TABS.optima.isDeliverable) {
                    return TABS.booking.showStep('deliveryOptions');
                }
                if (TABS.optima.hasResourcePool) {
                    return TABS.booking.showStep('resourceSelect');
                }
                if (TABS.optima.courseId) {
                    return TABS.booking.showStep('addStudentOrPay');
                }
                if (TABS.optima.followUpId) {
                    return TABS.optima.completeFollowUp(
                        form.querySelector('input[name=mobile]').value,
                        form.querySelector('input[name=password]').value
                    );
                }

                return TABS.booking.showStep('optimaPaymentMethod');
            }
            if (res.data) {
                if (res.data.indexOf('email') > -1) {
                    form.querySelector('.login-email-field').classList.remove('hide');
                }
                if (res.data.indexOf('address') > -1) {
                    form.querySelector('.login-address-field').classList.remove('hide');
                }
                if (res.data.indexOf('postal_code') > -1) {
                    form.querySelector('.login-postal-code-field').classList.remove('hide');
                }
                if (res.data.indexOf('city') > -1) {
                    form.querySelector('.login-city-field').classList.remove('hide');
                }
                if (res.data.indexOf('first_name') > -1) {
                    form.querySelector('.login-firstname-field').classList.remove('hide');
                }
                if (res.data.indexOf('last_name') > -1) {
                    form.querySelector('.login-lastname-field').classList.remove('hide');
                }
            }

            return TABS.booking.showError(res.message);
        });

    },

    register: function (e) {
        e.preventDefault();
        const $form = document.querySelector('[data-booking-step=' + TABS.optima.step + ']');
        if (!TABS.optima.runDSF && !TABS.booking.shouldSubmit(e, 'optimaRegister')) {
            return;
        }

        const errors = {};

        const formData = new FormData($form);
        errors.email = TABS.L10n.email.parse(formData.get('email')).required().validate();
        errors.fnr = TABS.L10n.nationalNumber.parse(formData.get('fnr')).validateNationalNumber();
        // errors.first_name = TABS.L10n.firstName.parse(formData.get('first_name')).required().validate()
        // errors.last_name = TABS.L10n.lastName.parse(formData.get('last_name')).required().validate()

        const errorCount = TABS.validation.toggleFormErrors($form, errors);
        if (errorCount > 0) {
            return;
        }
        if (TABS.optima.postingForm) {
            return;
        }
        TABS.optima.postingForm = true;
        TABS.booking.request('optima-register', $form, function (res, form) {
            const btn = $form.querySelector('.btn-primary');
            btn.textContent = btn.dataset.originalText;
            TABS.optima.postingForm = false;
            if (res.success) {
                TABS.optima.userId = res.user_id;
                TABS.optima.comment = formData.get('comment')
                TABS.optima.resetRegisterForm();
                if (res.with_interpreter) {
                    TABS.optima.withInterpreter.push(res.user_id);
                    TABS.optima.checkInterpreterCount();
                }
                if (res.product_terms) {
                    TABS.optima.productTerms = res.product_terms;
                }

                if (TABS.optima.followUpId) {
                    return TABS.optima.completeFollowUp(
                        formData.get('mobile'),
                        null,
                        formData.get('fnr')
                    );
                }
                if (TABS.optima.isDeliverable) {
                    return TABS.booking.showStep('deliveryOptions');
                }
                if (TABS.optima.hasResourcePool) {
                    return TABS.booking.showStep('resourceSelect');
                }
                if (TABS.optima.courseId) {
                    return TABS.booking.showStep('addStudentOrPay');
                }
                return TABS.booking.showStep('optimaPaymentMethod');
            }

            return TABS.booking.showError(res.message);
        });
    },

    registerDelivery: function (event) {
        event.preventDefault();
        const $form = document.querySelector('[data-booking-step=' + TABS.optima.step + ']');

        const errors = {};

        errors.deliveryOption = TABS.optima.deliveryOption ? [] : [TABS.$t('Du må velge et leveringsalternativ')];

        const errorCount = TABS.validation.toggleFormErrors($form, errors);
        if (errorCount > 0) {
            return;
        }

        TABS.booking.showStep('optimaPaymentMethod');
    },

    registerResource: function (event) {
        event.preventDefault();
        const $form = document.querySelector('[data-booking-step=' + TABS.optima.step + ']');
        const selectedClassId = parseInt($form.querySelector('#resource-class-id').value)
        TABS.optima.resourceClassIds[TABS.optima.userId] = selectedClassId;

        const errors = {};

        errors['resource-class-id'] = TABS.optima.resourceClassIds[TABS.optima.userId] ? [] : [TABS.$t('Du må velge et kjøretøy')];

        const errorCount = TABS.validation.toggleFormErrors($form, errors);
        if (errorCount > 0) {
            return;
        }

        const options = document.querySelectorAll('select[name="resource-class-id"] option[value="' + selectedClassId + '"]');
        options.forEach(option => {
            const newFreeSlots = parseInt(option.dataset['freeSlots']) - 1;
            option.dataset['freeSlots'] = newFreeSlots
            if (newFreeSlots <= 0) {
                option.setAttribute('disabled', 'disabled');
                option.text += ' (' + TABS.$t('Ingen flere ledige plasser') + ')';
            }
        })

        TABS.booking.showStep('addStudentOrPay')
    },
    toggleAddress: function (event) {
        const radio = event.target;
        TABS.optima.deliveryOption = radio.value;
    },

    addStudent: function (e, toPayment) {
        const $form = document.querySelector('[data-booking-step=' + TABS.optima.step + ']');

        const errors = {};

        const formData = new FormData($form);
        $form.querySelectorAll('input[type=text], input[type=tel], select').forEach(el => {
            if (el.hasAttribute('readonly')) {
                return;
            }
            switch (el.name) {
                case 'mobile':
                    return errors.mobile = TABS.L10n.mobile.parse(formData.get('mobile'), formData.get('countrycode') || undefined).validate();
                case 'fnr':
                    return errors.fnr = TABS.L10n.nationalNumber.parse(formData.get('fnr')).validateNationalNumber();
                case 'address':
                    return errors.address = TABS.L10n.varchar.parse(formData.get('address')).required().validate();
                case 'postal_code':
                    return errors.postal_code = TABS.L10n.zip.parse(formData.get('postal_code')).validate();
                case 'city':
                    return errors.city = TABS.L10n.varchar.parse(formData.get('city')).required().validate();
                case 'first_name':
                    return errors.first_name = TABS.L10n.firstName.parse(formData.get('first_name')).required().validate();
                case 'last_name':
                    return errors.last_name = TABS.L10n.lastName.parse(formData.get('last_name')).required().validate();
                case 'email':
                    return errors.email = TABS.L10n.email.parse(formData.get('email')).required().validate();
                case 'resource-class-id':
                    return errors['resource-class-id'] = Number.isInteger(parseInt(formData.get('resource-class-id'))) ? [] : [TABS.$t('Du må velge et kjøretøy')];
            }
        });

        const errorCount = TABS.validation.toggleFormErrors($form, errors);
        if (errorCount > 0) {
            return;
        }
        if (TABS.optima.postingForm) {
            // Loading
            return;
        }
        TABS.optima.postingForm = true;

        TABS.booking.request('optima-add-student', $form, function (res, form) {
            form.querySelectorAll('.btn-primary').forEach(el => {
                el.removeAttribute('disabled');
                el.textContent = el.dataset.originalText;
            });
            TABS.optima.postingForm = false;
            if (res.success) {
                TABS.optima.addStudentToUserList(res.user_id, form);
                if (res.with_interpreter) {
                    TABS.optima.withInterpreter.push(res.user_id);
                    TABS.optima.checkInterpreterCount();
                }
                if (formData.get('resource-class-id')) {
                    TABS.optima.resourceClassIds[res.user_id] = parseInt(formData.get('resource-class-id'));
                    form.querySelector('select[name=resource-class-id]').value = 0;
                }
                form.querySelector('input[name=fnr]').value = '';
                TABS.optima.updateTotalPrice();
                return TABS.booking.showStep('addStudentOrPay');
            } else {
                TABS.booking.showError(res.message);
            }
        });
    },

    updateTotalPrice: function () {
        const data = new FormData;
        data.append('userId', TABS.optima.userId);
        data.append('studentIds', TABS.optima.addStudentIds);
        data.append('courseId', TABS.optima.courseId);
        data.append('classId', TABS.optima.classId);
        data.append('productType', TABS.optima.productType);
        data.append('officeId', TABS.api.officeId);

        axios.post(TABS.api.getEndPoint('optima-total-price'), data)
        .then(response => response.data)
        .then(res => {
            if (!res.success) {
                return;
            }
            document.getElementById('product-booking-detail').outerHTML = res.html;
        });
    },

    resetRegisterForm: function () {
        document.querySelectorAll('.register-details input').forEach(input => {
            input.value = '';
            input.removeAttribute('readonly');
            input.removeAttribute('disabled');
        });
        document.querySelector('.register-details').classList.add('hide');
        document.querySelector('input[name=with-interpreter]').checked = false;
    },

    addStudentToUserList: function (userId, form) {
        TABS.optima.addStudentIds.push(userId);

        const userList = document.querySelector('.user-list');
        const fullname = form.querySelector('input[name=first_name]').value + ' ' + form.querySelector('input[name=last_name]').value;
        userList.classList.remove('hide');
        userList.insertAdjacentHTML('beforeend', '<p data-student-id="' + userId + '"><strong><i class="tabs-fa tabs-fa-block tabs-fa-user"></i> ' + TABS.$t('Navn') + ': ' + fullname + '</strong></p>');
        // Clear form for next participant
        TABS.optima.resetRegisterForm();
    },

    paymentCallback: function (res, form) {
        document.querySelector('[data-booking-step=optimaPayment] .btn-primary').removeAttribute('disabled');
        document.querySelector('[data-booking-step=optimaPayment] .btn-primary').textContent = document.querySelector('[data-booking-step=optimaPayment] .btn-primary').dataset.originalText;
        TABS.booking.setLoading(false);
        if (!res.success) {
            TABS.booking.showError(res.message);
            return;
        }

        TABS.booking.showStep('optimaCompleted');
    },

    getPaymentData: function () {
        return {
            user_id: TABS.optima.userId,
            password: TABS.optima.pw,
            hash: TABS.optima.hash,
            class_id: TABS.optima.classId,
            course_id: TABS.optima.courseId,
            teacher_id: TABS.optima.teacherId,
            product_id: TABS.optima.productId,
            package_id: TABS.optima.packageId,
            start: TABS.optima.start,
            end: TABS.optima.end,
            add_student_ids: TABS.optima.addStudentIds,
            with_interpreters: TABS.optima.withInterpreter,
            delivery_option: TABS.optima.deliveryOption,
            shipping_address: TABS.optima.shippingAddress,
            product_terms: TABS.optima.productTerms,
            current_url: window.location.href,
            resource_class_ids: TABS.optima.resourceClassIds,
            comment: TABS.optima.comment,
        };
    },

    triggerNets: function () {
        TABS.booking.setFeedback('');
        document.querySelectorAll('[data-booking-step]').forEach(el => el.classList.add('hide'));
        TABS.booking.setLoading(true);

        if (TABS.optima.postingForm) {
            return;
        }
        TABS.optima.postingForm = true;
        const data = TABS.optima.getPaymentData();

        TABS.booking.request('optima-trigger-nets', null, function (res) {
            TABS.optima.postingForm = false;
            TABS.optima.startReservationTimeout();

            TABS.booking.setLoading(false);
            if (res.success) {
                if (res.data.transaction) {
                    TABS.booking.showStep('nets');
                    TABS.optima.transactionRef = res.data.transaction;
                    const checkoutOptions = {
                        checkoutKey: res.data.netsEasyCheckoutKey,
                        paymentId: res.data.paymentId,
                        containerId: "checkout-container-div",
                        language: "sv-SE",
                    };
                    const checkout = new Dibs.Checkout(checkoutOptions);

                    if (!TABS.optima.netsCallbackRegistered) {
                        checkout.on('payment-completed', function (response) {
                            TABS.optima.clearReservationTimeout();
                            TABS.optima.paymentInProgress(response['paymentId'], TABS.optima.transactionRef);
                            TABS.booking.showStep('optimaCompleted');
                            TABS.optima.netsCallbackRegistered = true;
                        });
                    }
                }
            } else {
                TABS.optima.clearReservationTimeout();
                TABS.booking.showStep('optimaPaymentMethod');
                TABS.booking.showError(res.error);
            }
        }, data);
    },

    paymentInProgress: function (paymentId, ref) {
        TABS.booking.request('payment-in-progress/' + paymentId, null, null, {ref});
    },

    triggerSwish: function () {
        TABS.booking.setFeedback('');
        document.querySelectorAll('[data-booking-step]').forEach(el => el.classList.add('hide'));
        TABS.booking.setLoading(true);

        const data = TABS.optima.getPaymentData();

        TABS.booking.request('optima-trigger-swish', null, function (res) {

            TABS.optima.startReservationTimeout();

            TABS.booking.setLoading(false);
            if (res.success) {
                if (res.data.redirect) {
                    // redirect to swish
                    TABS.optima.transactionRef = res.data.transaction;
                    TABS.optima.checkSwishPayment();
                    window.onbeforeunload = null;
                    TABS.booking.showStep('swishQr');
                    document.querySelector('.swish-qr-code').style.display = 'none';
                    document.querySelector('.swish-deeplink').setAttribute('href', res.data.message);
                    document.querySelector('.swish-deeplink').style.display = 'block';
                    document.querySelector('.loader').remove();
                    return;
                }
                TABS.booking.showStep('swishQr');
                TABS.optima.transactionRef = res.data.transaction;
                TABS.optima.swishQr = res.data.qr_code;
                document.getElementById('swish-qr-code').setAttribute('src', 'data:image/png;base64,' + TABS.optima.swishQr);
                document.querySelector('.swish-qr-code').setAttribute('src', 'data:image/png;base64,' + TABS.optima.swishQr);
                if (!res.data.qr_code) {
                    document.querySelector('.swish-qr-code').style.display = 'none';
                }
                if (res.data.message) {
                    document.getElementById('swish-payment-message').textContent = res.data.message;
                    document.getElementById('swish-payment-message').classList.remove('hide');
                }
                TABS.optima.checkSwishPayment();
                return;
            } else {
                TABS.optima.clearReservationTimeout();
                TABS.booking.showStep('optimaPaymentMethod');
                return TABS.booking.showError(res.error);
            }
        }, data);
    },

    checkSwishPayment: function () {
        TABS.booking.request('p-status', null, function (res) {
            TABS.optima.statusAttempts++;

            if (!document.querySelector('.tabs-modal.show') && !document.getElementById('p-fallback-status') && !document.getElementById('swish-payment-result')) {
                // Modal closed. Don't fetch status anymore
                return;
            }
            if (res.inprogress) {
                setTimeout(function () {
                    TABS.optima.checkSwishPayment();
                }, TABS.optima.secondsBetweenEachCheck * 1000);
            } else {
                TABS.optima.clearReservationTimeout();
                TABS.optima.showPaymentResult(res);
            }
        }, {ref: TABS.optima.transactionRef}, 3);
    },

    checkPaymentStatus: function () {
        TABS.booking.request('p-status', null, function (res) {
            TABS.optima.statusAttempts++;

            if (!document.querySelector('.tabs-modal.show') && !document.getElementById('p-fallback-status')) {
                // Modal closed. Don't fetch status anymore
                return;
            }
            if (res.inprogress) {
                TABS.booking.setLoading(true);
                setTimeout(function () {
                    TABS.optima.checkPaymentStatus();
                }, TABS.optima.secondsBetweenEachCheck * 1000);
            } else {
                TABS.optima.clearReservationTimeout();
                TABS.optima.showPaymentResult(res);
            }
        }, {ref: TABS.optima.transactionRef}, 3);
    },

    showPaymentResult: function (res) {
        if (document.querySelector('.tabs-modal.show') || document.getElementById('swish-payment-result')) {
            switch (res.data.status) {
                case 'approved':
                    return TABS.booking.showStep('optimaCompleted');

                case 'rejected':
                case 'failed':
                    if (document.getElementById('swish-payment-result')) {
                        document.getElementById('swish-payment-result').classList.remove('alert-info');
                        document.getElementById('swish-payment-result').classList.add('alert-danger');
                        document.getElementById('swish-payment-result').classList.remove('hide');
                        document.getElementById('swish-payment-result').textContent = res.data.message;
                    }
                    if (document.getElementById('payment-result')) {
                        document.getElementById('payment-result').classList.remove('alert-info');
                        document.getElementById('payment-result').classList.add('alert-danger');
                        document.getElementById('payment-result').classList.remove('hide');
                        document.getElementById('payment-result').textContent = res.data.message;
                    }
            }
        } else if (document.getElementById('p-fallback-status')) {
            switch (res.data.status) {
                case 'approved':
                    document.getElementById('p-fallback-status').querySelector('.alert').classList.remove('alert-info');
                    document.getElementById('p-fallback-status').querySelector('.alert').classList.add('alert-success');
                    document.getElementById('p-fallback-status').querySelector('.alert').textContent = res.data.message;
                    break;
                case 'rejected':
                case 'failed':
                    document.getElementById('p-fallback-status').querySelector('.alert').classList.remove('alert-info');
                    document.getElementById('p-fallback-status').querySelector('.alert').classList.add('alert-danger');
                    document.getElementById('p-fallback-status').querySelector('.alert').textContent = res.data.message;
            }
            document.getElementById('p-fallback-status').querySelector('.spinner').classList.add('hide');

        }
    },

    navigateToSwishApp: function (event, el) {
        event.preventDefault();
        var href = el.getAttribute('href');
        if (window.self === window.top) {
            window.location = href;
        } else {
            window.triggerSwishFailedTimeout = window.setTimeout(function () {
                TABS.booking.showError(TABS.$t('Kunne ikke åpne Swish. Last siden på nytt og prøv igjen med en annen betalingsløsning.'));
            }, 1000);
            window.top.postMessage({
                eventName: 'swish:payment',
                swishPaymentDeeplink: href,
            }, '*');
            TABS.booking.showError(TABS.$t('Videresender deg nå til Swish appen.'));
        }
    },

    getReservationTimeoutLimitInSeconds: function () {
        return 1000 * 60 * 10; // 10 minutes
    },

    startReservationTimeout: function () {
        TABS.optima.reservationTimeout = window.setTimeout(function () {
            TABS.booking.setLoading(false);
            TABS.booking.showStep('reservationTimeout');
            TABS.optima.clearReservedBooking('timeout');
        }, TABS.optima.getReservationTimeoutLimitInSeconds());

        // Define the handler function once and store it
        TABS.optima.modalCloseHandler = function () {
            TABS.optima.clearReservedBooking('js-close');
        };

        // Add the stored handler function
        document.querySelectorAll(".modal.show, .tabs-modal").forEach(el => {
            el.addEventListener("hidden.bs.modal", TABS.optima.modalCloseHandler);
        });
    },

    clearReservationTimeout: function () {
        window.clearTimeout(TABS.optima.reservationTimeout);
        window.onbeforeunload = null;
        
        // Remove the stored handler function
        document.querySelectorAll(".modal.show, .tabs-modal").forEach(el => {
            el.removeEventListener("hidden.bs.modal", TABS.optima.modalCloseHandler);
        });
        TABS.optima.reservationTimeout = null;
    },

    clearReservedBooking: function (reason) {
        TABS.booking.request('clear-reserved', null, function (res) {
            // Res isn't used.
        }, {
            ref: TABS.optima.transactionRef,
            user_id: TABS.optima.userId,
            reason: reason,
        });
        TABS.optima.clearReservationTimeout();
    },

    closeModal: function () {
        document.querySelectorAll(".modal.show,.tabs-modal").forEach(el => {
            el.classList.remove('show');
        });
    },
    completeFollowUp: function (username, password, fnr) {
        TABS.booking.setFeedback('');
        TABS.booking.setLoading(true);
        TABS.booking.request('do_booking', null, function (res) {
            TABS.booking.setLoading(false);
            if (res.success || res.status === 'ok') {
                TABS.booking.showStep('followUpComplete');
                return;
            }
            TABS.booking.showStep('login');
            TABS.booking.showError(res.message);

        }, {
            follow_up_id: TABS.optima.followUpId,
            username: username,
            password: password,
            fnr: fnr,
            terms_approved: true,
            userId: TABS.optima.userId,
            officeId: TABS.api.officeId,
        });
    },
    iframeSwishCheck: function () {
        if (TABS.api.inIframe() && !TABS.api.loadedOutsideIframe) {
            TABS.booking.request('api-not-loaded-outside-iframe');
        }
    }
}